<template>
  <BootstrapVueTable
    :title="title"
    :subtitle="subtitle"
    :items="table_data"
    :fields="table_fields" />
</template>

<script>
import axios from 'axios'
import errorRoutingMixin from '@/mixins/errorRoutingMixin'
import data_formats from '@/utils/data_formats'
import BootstrapVueTable from '@/components/BootstrapVueTable'

export default {
  name: 'Project_agp_data',
  components: {BootstrapVueTable},
  mixins: [errorRoutingMixin],
  props: ['reference_entity', 'reference_year', 'reference_month'],
  data () {
    return {
      title: "Données AGP",
      subtitle: "Cette table présente les données venant directement d'AGP. Elle permet une vue rapide de l'ensemble des projets.",
      raw_data: [],
      table_data: [],
      table_fields: [],
    }
  },
  watch: {
    all_props () {
      this.load_server_data()
    }
  },
  created () {
    this.load_server_data()
  },
  computed: {
    all_props () {
      return [
        this.reference_entity,
        this.reference_year,
        this.reference_month  
      ]
    },
  },
  methods: {
    load_server_data () {
      if (! this.reference_entity) return  // If user is not yet authenticated. do nothing
      let url = 'webapi/project-financials?entity=' + this.reference_entity + '&year=' + this.reference_year + '&month=' + this.reference_month 
      axios.get(url, {headers: {'Authorization': 'Bearer ' + this.$cookies.get('jwt_access')}})
        .then(response => this.raw_data = response.data)
        .then(_ => this.fill_table())
        .catch(error => {
          console.log(error)
          this.$router.push(this.routeOnError(error.response.status))
        })
    },

    fill_table() {
      this.table_data = data_formats.col_to_row_format(this.raw_data)
      let sortable = {sortable: true}
      let number_format = {formatter: data_formats.number_format_frch_rounded, class: 'text-right', ...sortable}
      this.table_fields = [
        {key: 'IDPROJECTHESSO', label: 'No.', ...sortable}, 
        {key: 'PROJECTMANAGERINITIAL', label: 'Resp.', ...sortable}, 
        {key: 'PROJECTACRONYM', label: 'Acronyme', ...sortable}, 
        {key: 'IDPILIER', label: 'Pilier', ...sortable}, 
        {key: 'PROJECTCATSHORT', label: 'Type', ...sortable}, 
        {key: 'AGPBUDGET', label: 'Budget AGP', ...number_format}, 
        {key: 'AgpBudgetStartOfYear', label: 'Solde AGP janv. ', ...number_format}, 
        {key: 'AgpCostFdt', label: 'Coût Fdt', ...number_format}, 
        {key: 'AgpCostHes', label: 'Coût HES', ...number_format}, 
        {key: 'AgpCostBsm', label: 'Coût BSM', ...number_format}, 
        {key: 'AgpTotalCost', label: 'Coût total', ...number_format}, 
        {key: 'AgpRemainingBudget', label: 'Solde AGP actuel', ...number_format}
      ]
    },
  }
}
</script>